<template>
  <!-- TODO: ask this type -->
  <div class="relative w-full">
    <input
      :id="inputId"
      v-model="content"
      :class="[
        'peer w-full px-4 py-3 text-base focus:ring-2 focus:ring-primary-500',
        hasBorder
          ? 'border-gray-300 border'
          : 'border-0 border-transparent focus:border-0 focus:ring-0',
      ]"
      type="text"
      inputmode="numeric"
      pattern="\d*"
      :placeholder="label"
      :aria-label="ariaLabel"
      :aria-required="required || undefined"
      @input="handleInput"
    />
    <label
      :for="inputId"
      class="peer-placeholder-shown:text-gray-500 absolute -top-2 left-2 bg-white px-2 text-xs transition-all duration-200 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-xs peer-focus:font-bold"
    >
      {{ label }}
    </label>
  </div>
</template>

<script lang="ts">
import type { WritableComputedRef } from 'vue'

export default defineComponent({
  name: 'NumberInput',
  props: {
    modelValue: {
      type: String as PropType<string>,
      default: '',
    },
    label: {
      type: String,
      default: 'Number',
    },
    ariaLabel: {
      type: String as PropType<string>,
      default: undefined,
    },
    required: {
      type: Boolean,
      default: false,
    },
    inputId: {
      type: String as PropType<string>,
      required: true,
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
    enableKeyEvents: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],

  setup(props, { emit }) {
    const content: WritableComputedRef<string> = computed({
      get() {
        return props.modelValue
      },
      set(newValue: string): void {
        emit('update:modelValue', newValue)
      },
    })

    const handleInput = (event: Event) => {
      const input = event.target as HTMLInputElement
      const filtered = input.value.replace(/\D/g, '')
      input.value = filtered
      emit('update:modelValue', filtered)
    }

    return {
      content,
      handleInput,
    }
  },
})
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
